module.exports = __webpack_public_path__ + "static/media/visual-studio-logo.3c17f836.jpeg";